import { FC } from 'react';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import Header from '@/components/XPower/elements/Header';
import MoreButton from '@/components/XPower/elements/MoreButton';
import { StreamIcon } from '@/components/XPower/svg';
import ProgressGroup from '@/components/XPower/elements/ProgressGroup';
import Video from '@/components/XPower/elements/Video';
import { EU_LIST } from '@/components/XPower/constants';
import getLocal from '@/app/utils/getLocal';

const XStream: FC = () => {
    const { t } = useLang('xcode.xstream');
    const { locale } = getLocal();

    let mediaList = [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718951269229/2.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718951246574/X-stream.jpg',
            text: t.rich('media.media_text1', {
                line: (text: string) => <span>{text}</span>,
            }),
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718700911597/2-1.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718700944369/X-stream2.jpg',
            text: t.rich('media.media_text2', {
                line: (text: string) => <span>{text}</span>,
            }),
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718700979184/3.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718700955237/X-stream3.jpg',
            text: t.rich('media.media_text3', {
                line: (text: string) => <span>{text}</span>,
            }),
        },
    ];

    if (EU_LIST.includes(locale)) {
        mediaList = [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1724730177201/stream.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1724730189936/stream_m.jpg',
                text: t.rich('media.media_text2', {
                    line: (text: string) => <span style={{ whiteSpace: 'pre-wrap' }}>{text}</span>,
                }),
            },
        ];
        if (locale === 'uk') {
            mediaList[0].pc = 'https://websiteoss.ecoflow.com/upload/image/1724730343294/stream_uk.jpg';
            mediaList[0].h5 = 'https://websiteoss.ecoflow.com/upload/image/1724730357648/stream_ukm.jpg';
        }
    }

    const progressList = [
        {
            text: t('progress.progress_text1'),
            number: 90,
            unit: t('progress.progress_unit'),
        },
        {
            text: t('progress.progress_text2'),
            number: EU_LIST.includes(locale) ? 60 : 50,
            unit: t('progress.progress_unit'),
        },
    ];

    return (
        <div className={styled.XStream}>
            <Header icon={<StreamIcon />} desc={t('title')} inset subtitle={t('subtitle')} />
            <div className="big-central media_box">
                <Video src="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1718700578464/X-stream.mp4" />
            </div>
            <div className="middle-central">
                <div className="text_box">
                    <div className="left font-desc">
                        {t.rich('text.left', {
                            line: (text: string) => <span>{text}</span>,
                        })}
                    </div>
                    <div className="right font-desc">
                        {t('text.right_speed')}
                        <p>{t('text.right_fast')}</p>
                        {t('text.right_up')}
                    </div>
                </div>
                <p className="tips">{t('text.tips')}</p>
                <ProgressGroup title={t('progress.progress_title')} list={progressList} />
            </div>
            <MoreButton text={t('btn_more')} mediaList={mediaList} />
        </div>
    );
};

export default XStream;
